import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { ProgramForm } from '../forms'
import * as Types from 'types'
import { yankBy, isOtherType, getOtherTypeId } from 'utils'
import { get } from 'lodash'
import { ExpandableItem } from 'components'

const propTypes = {
  program: Types.program,
  onSubmit: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  approachTypes: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  disciplines: PropTypes.arrayOf(Types.discipline).isRequired,
  isNewProgram: PropTypes.bool,
  grades: PropTypes.arrayOf(Types.grade).isRequired,
  programTypes: PropTypes.arrayOf(Types.programType).isRequired,
  outcomeTypes: PropTypes.arrayOf(Types.outcomeType).isRequired,
  languages: PropTypes.arrayOf(Types.language).isRequired,
  artistId: PropTypes.number,
  isApplication: PropTypes.bool,
  /** When set, used as the redux-form name (e.g. application flow needs unique names). */
  formName: PropTypes.string,
}

const defaultProps = {
  disabled: false,
  isNewProgram: false,
  isApplication: false,
}

function ProgramBlade({
  program,
  onSubmit,
  onSubmitSuccess,
  onDelete,
  disabled,
  grades,
  programTypes,
  outcomeTypes,
  approachTypes,
  disciplines,
  isNewProgram,
  languages,
  artistId,
  isApplication,
  formName,
}) {
  const [expandForm, setExpandForm] = useState(isNewProgram)
  const initialValues = program ? program : {}

  const [otherOutcome, definedOutcomes] = useMemo(() => {
    const outcomes = get(initialValues, 'outcomes', [])
    return yankBy(outcomes, isOtherType)
  }, [initialValues])
  const [otherApproach, definedApproaches] = useMemo(() => {
    const approaches = get(initialValues, 'approaches', [])
    return yankBy(approaches, isOtherType)
  }, [initialValues])
  const [otherLanguage, definedLanguages] = useMemo(() => {
    const languages = get(initialValues, 'languages', [])
    return yankBy(languages, isOtherType)
  }, [initialValues])
  const Blade = () => (
    <div className="expander-content">
      <ProgramForm
        name={
          formName ||
          (program ? `partner-program-${program.id}` : 'partner-program')
        }
        initialValues={{
          ...initialValues,
          outcomes: definedOutcomes,
          otherOutcome: {
            ...otherOutcome,
            outcomeTypeId: getOtherTypeId(outcomeTypes),
          },
          approaches: definedApproaches,
          otherApproach: {
            ...otherApproach,
            approachId: getOtherTypeId(approachTypes),
          },
          languages: definedLanguages,
          otherLanguage: {
            ...otherLanguage,
            languageId: getOtherTypeId(languages),
          },
        }}
        onSubmit={onSubmit}
        onSubmitSuccess={(params) => {
          setExpandForm(false)
          return onSubmitSuccess(params)
        }}
        onDelete={onDelete}
        disabled={disabled}
        grades={grades}
        programTypes={programTypes}
        outcomeTypes={outcomeTypes}
        approachTypes={approachTypes}
        disciplines={disciplines}
        isNewProgram={isNewProgram}
        languages={languages}
        artistId={artistId}
        isApplication={isApplication}
      />
    </div>
  )

  return (
    <div>
      {isNewProgram ? (
        <Blade />
      ) : (
        <ExpandableItem
          headerTitle={get(program, 'name', 'New Program')}
          startExpanded={expandForm}
        >
          <Blade />
        </ExpandableItem>
      )}
    </div>
  )
}

ProgramBlade.propTypes = propTypes

ProgramBlade.defaultProps = defaultProps

export default ProgramBlade
